import { render } from "./valForm.vue?vue&type=template&id=46fbacf6&ts=true"
import script from "./valForm.vue?vue&type=script&lang=ts"
export * from "./valForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__